import { useQuery } from 'react-query';
import { getInvoicePDF } from '../api/invoiceApi';

const invoiceQueries = {
  base: (routeToken) => ({ queryKey: ['invoice', routeToken] }),
  invoicePDF: (routeToken, invoiceId) => ({
    queryKey: [...invoiceQueries.base(routeToken).queryKey, invoiceId, 'pdf'],
    queryFn: () => getInvoicePDF(routeToken, invoiceId),
  }),
};

export function useGetInvoicePDF(routeToken, invoiceId, options = {}) {

  return useQuery({
    ...invoiceQueries.invoicePDF(routeToken, invoiceId),
    ...options,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (error?.response?.status === 403) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
